import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Done from '@material-ui/icons/Done';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import Publish from '@material-ui/icons/Publish';

import ORTypography from 'components/ORTypography/ORTypography';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  status: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  dates: PropTypes.string.isRequired,
};

export function formatDateRange(date) {
  const dateArray = date.split('-');
  const dateYear = dateArray[0].substring(2);
  let dateMonth = Number(dateArray[1]);
  let dateDay = dateArray[2].split('T')[0];

  // Correct range for dates that straddle years
  let prevDateMonth;

  if (dateMonth === 1) {
    prevDateMonth = 12;
  } else {
    prevDateMonth = dateMonth - 1;
  }

  // zero-pad the month and day values
  prevDateMonth = prevDateMonth.toString().padStart(2, '0');
  dateMonth = dateMonth.toString().padStart(2, '0');
  dateDay = dateDay.toString().padStart(2, '0');

  return `${prevDateMonth}/${dateDay} - ${dateMonth}/${dateDay}/${dateYear}`;
}

export function UnstyledInvoiceItem({ classes, status, total, dates }) {
  let statusClass;

  if (status === 'Past due') {
    statusClass = 'pastDue';
  } else if (status === 'Paid') {
    statusClass = 'paid';
  } else {
    statusClass = 'estimate';
  }

  return (
    <TableRow>
      <TableCell classes={{ root: classes.tableCellRoot }}>
        <Publish className={classes.fileDownload} fontSize="large" />
        <ORTypography align="left" component="p" className={classes.invoiceInfo}>
          {formatDateRange(dates)}
          <br />
          <span className={classes[statusClass]}>
            Total: &#36;
            {(total / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            <span className={classes.statusMsg}>({status})</span>
          </span>
        </ORTypography>
      </TableCell>
      <TableCell>
        {status === 'Paid' && <Done classes={{ root: classes.checkmarkRoot }} fontSize="large" />}
        {status === 'Past due' && (
          <NotificationImportant classes={{ root: classes.notificationRoot }} fontSize="large" />
        )}
        {status === 'Estimate' && (
          <ErrorOutline classes={{ root: classes.estimateRoot }} fontSize="large" />
        )}
      </TableCell>
    </TableRow>
  );
}

UnstyledInvoiceItem.propTypes = propTypes;

const styles = (theme) => ({
  fileDownload: {
    color: theme.customColors.mediumGrey,
    transform: 'rotate(180deg)',
  },
  invoiceInfo: {
    marginLeft: theme.spacing(2),
    display: 'inline-block',
  },
  paid: {
    color: theme.palette.secondary.main,
  },
  pastDue: {
    color: theme.customColors.red,
  },
  estimate: {
    color: theme.customColors.burntYellow,
  },
  checkmarkRoot: {
    color: theme.palette.secondary.main,
    float: 'right',
  },
  notificationRoot: {
    color: theme.customColors.red,
    float: 'right',
  },
  estimateRoot: {
    color: theme.customColors.burntYellow,
    float: 'right',
  },
  statusMsg: {
    marginLeft: theme.spacing(0.5),
  },
  tableCellRoot: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
});

export default withStyles(styles)(UnstyledInvoiceItem);
